import { fetchFips } from '../services/searchService'

// Phase 2 (search overhaul): FIPS lookups no longer hit Elasticsearch directly from the browser (no
// more REACT_APP_ELASTIC_API_KEY / ElasticsearchAPIConnector). The county/state -> FIPS resolution
// now runs server-side via the resactly-service `/search/fips` proxy (REACT_APP_SERVICE_URL) which
// forwards to resactly-dis. `getCountyAndStateByPlaceId` still uses the Google Maps Places library.

declare global {
  interface Window {
    maps: {}
  }
}

export const findFipsByCountyState = async (
  county: string,
  countyState: string,
): Promise<string | null> => {
  try {
    return await fetchFips({ county, state: countyState })
  } catch (error) {
    return null
  }
}

export const getCountyAndStateByPlaceId = async (
  placeId: string,
): Promise<{ county: string; countyState: string } | null> => {
  try {
    // @types/google.maps 3.58.1 (local) types importLibrary as returning a union, so the cast is
    // required; newer @types resolved in CI narrow it and flag the cast as unnecessary — disable
    // that CI-only rule so both environments compile.
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
    const { Place } = (await google.maps.importLibrary('places')) as google.maps.PlacesLibrary
    const place = new Place({
      id: placeId,
      requestedLanguage: 'en',
    })
    await place.fetchFields({
      fields: [
        'displayName',
        'formattedAddress',
        'location',
        'addressComponents',
      ],
    })
    const county = place.addressComponents?.find((comp) =>
      comp.types.includes('administrative_area_level_2'),
    )?.longText
    const countyState = place.addressComponents?.find((comp) =>
      comp.types.includes('administrative_area_level_1'),
    )?.longText

    return county && countyState ? { county, countyState } : null
  } catch (error) {
    return null
  }
}
